module.exports = "pegasus/assets/circle-tumblr.png";